var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.debug)?_c('div',[_c('button',{staticClass:"btn btn-light",on:{"click":_vm.show}},[_vm._v("\n    JSON\n    "),_c('icon',{attrs:{"name":_vm.icon}})],1),_vm._v(" "),(_vm.isshow)?_c('div',{staticClass:"shadow bg-dark container"},[_c('pre',{staticClass:"p-2 text-white"},[_vm._v(_vm._s(_vm.data))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9445608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cJson.vue
// module id = null
// module chunks = 